
<template>
    <div class="form-block">

        <div>
            <h2 class="form-block__title mb-3">{{title_form}}</h2>
            <div class="form-block_body">
                <div class="black_block mb-3">
                    <div class="d-flex position-relative">
                        <div class="black_block__title">User name</div>                    
                        <input v-model="model.name" type="text" class="form-control" :class="{'is-invalid': error_name}" autocomplete="off" @focus="focusOnAutocomplete"  @blur="removeFocusOnAutocomplete"/>
                        <!-- <div @click="clearinput('name')" class="btn-close"></div> -->
                    </div>
                </div>
                <div class="black_block mb-3">
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Password</div>
                        <input v-model="model.password" type="password" class="form-control" :class="{'is-invalid': error_name}" autocomplete="off" @focus="focusOnAutocomplete"  @blur="removeFocusOnAutocomplete"/>
                        <!-- <div @click="clearinput('password')" class="btn-close"></div> -->
                    </div>
                </div>
            </div>
         
        </div>

        <div class="form-block__footer d-flex justify-content-between">            
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">Cancel</button>                
                <button  @click="sendUser" class="btn btn-primary">{{ text_submit }}</button>
            </div>
        </div>

    </div>
</template>

<script>
import {bus} from '../../bus';
import iconsort from "../iconsort";
import Vue from 'vue';
import VueInfiniteAutocomplete from 'vue-infinite-autocomplete';

// import DisableAutocomplete from 'vue-disable-autocomplete';
// import NoAutoComplete from 'vue-no-autocomplete';

// // const DisableAutocomplete = require('vue-disable-autocomplete');


// Vue.use(DisableAutocomplete);
// Vue.use(NoAutoComplete);

// Vue.use(DisableAutocomplete);
// Vue.use(NoAutoComplete);

export default {
    props: ['crud', 'data'],
    data(){
        return{
            title_form: '',
            text_submit: 'Create',
            model: {
                name: '',
                password: ''                
            },
            error_name: false,
            step: 1,
            sort_name: 'up'
        }
    },
    methods: {
        removeFocusOnAutocomplete(e){
            e.target.readOnly = true;
        },
        focusOnAutocomplete(e){
            e.target.removeAttribute('readonly');
        },        
        clearinput(id){
            if(id === 'name'){
                // this.model.name = '';
            }
        },
        closePopup(){
            bus.$emit('openpopup' , {
                open: false
            });
        },
        setStep(id){
            this.step = id;
        },
        sendUser(){
            if(this.validform()){

                let data = this.model;

                if(this.crud === 'create'){
                    axios.post('/users', data)
                    .then(function (response) {                                                
                        console.log('add response data: ', response.data);

                        bus.$emit('userAdded');

                        
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
                }

                if(this.crud === 'edit'){
                    bus.$emit('edituser', this.model);
                }

                bus.$emit('openpopup', {
                    open: false
                });

            }

        },
        sortName(){

            if(this.sort_name === 'up'){
                this.sort_name = 'down';
            }else{
                this.sort_name = 'up';
            }
        },
        validform(){

            this.error_name = false;

            if(this.model.name === ''){
                this.error_name = true;
                return false;
            }

            return true;

        }
    },
    mounted(){

        if(this.data){
            this.model = this.data;
        }

        if(this.crud === 'create'){
            this.title_form = 'Add user';
            this.text_submit = 'Create';

            for(const itemProp in this.model)                
                this.$set(this.model, itemProp, '');
            


        }

        // if(this.crud === 'edit'){
        //     this.title_form = 'Update category';
        //     this.text_submit = 'Update';
        // }

    },
    components: {
        iconsort,
        "vue-infinite-autocomplete": VueInfiniteAutocomplete
    }
}
</script>

<style scoped lang="scss">
    .btn-close{
        margin-left: 1rem;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
